import { ReduxBaseReducer, IReduxBase } from '../../redux-base/redux.base.reducer';
import { ReflectiveInjector } from '@angular/core';
import { TagUpdateActions } from './tag-update.actions';
import { NgRxAction } from '../../action.interface';

export interface IUpdateTag extends IReduxBase {
}

export function tagUpdateReducer(state, {type, payload}: NgRxAction) {
  return ReduxBaseReducer.getConfig(ReflectiveInjector.resolveAndCreate(
    [TagUpdateActions]).get(TagUpdateActions), state, {type, payload});
}
